var map = {
	"./guide_0.jpg": "E4w8",
	"./guide_1.jpg": "cEmM",
	"./guide_2.jpg": "rvUP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "G75t";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home ^\.\/guide_.*\.jpg$
// module id = G75t
// module chunks = 1